'use client';

import { FC } from 'react';
import dynamic from 'next/dynamic';

const Hero = dynamic(() => import('./components/Hero'));
const Timeline = dynamic(() => import('./components/Timeline'));
const ByTheNumbers = dynamic(() => import('./components/ByTheNumbers'));
const TrustCompliance = dynamic(() => import('./components/TrustCompliance'));
const Location = dynamic(() => import('./components/Location'));

type IAboutPageProps = object;

const AboutPage: FC<IAboutPageProps> = () => {
  return (
    <>
      <Hero />
      <Timeline />
      <ByTheNumbers />
      <TrustCompliance />
      <Location />
    </>
  );
};

export default AboutPage;
